/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function OptionAdd({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#OptionAdd_svg__a)"><path d="M0 0h16v16H0z" /><path fill="currentColor" fillRule="evenodd" d="M12 .4a.6.6 0 0 1 .6.6v2.4H15a.6.6 0 1 1 0 1.2h-2.4V7a.6.6 0 1 1-1.2 0V4.6H9a.6.6 0 0 1 0-1.2h2.4V1a.6.6 0 0 1 .6-.6ZM.9 1.5a.6.6 0 0 1 .6-.6h5a.6.6 0 0 1 .6.6v5a.6.6 0 0 1-.6.6h-5a.6.6 0 0 1-.6-.6v-5Zm1.2.6v3.8h3.8V2.1H2.1ZM.9 12a3.1 3.1 0 1 1 6.2 0 3.1 3.1 0 0 1-6.2 0ZM4 10.1a1.9 1.9 0 1 0 0 3.8 1.9 1.9 0 0 0 0-3.8Zm4.9-.6a.6.6 0 0 1 .6-.6h5a.6.6 0 0 1 .6.6v5a.6.6 0 0 1-.6.6h-5a.6.6 0 0 1-.6-.6v-5Zm1.2.6v3.8h3.8v-3.8h-3.8Z" clipRule="evenodd" /></g><defs><clipPath id="OptionAdd_svg__a"><path d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;